import type { ApiDepartment } from '@/types/department'

export function findDepartmentById(
	departments: ApiDepartment[] | undefined,
	departmentId: number | undefined
): ApiDepartment | undefined {
	if (!departments || departmentId == null) return undefined

	for (const department of departments) {
		if (department.id === departmentId) return department

		const matched = findDepartmentById(department.children, departmentId)
		if (matched) return matched
	}

	return undefined
}
